import { TextBadge } from 'components/Badge/TextBadge';
import { SearchFacetAccordionItem } from 'modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from 'modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from 'modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { SEARCH_INTERNSHIP_REFINEMENT_LABELS } from 'modules/search/constants/refinements/searchInternshipRefinementTypes';
import { useSearchFacetSelectedValues } from 'modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from 'modules/search/types/SearchRefinementVariant';
import { PAYMENT_LEVELS } from 'utils/constants/general/paymentLevels';

type Props = {
  variant?: SearchRefinementVariant;
};

export function PaymentFacet({ variant = 'dropdown' }: Props) {
  const selectedFacetValues = useSearchFacetSelectedValues('payment');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="payment"
      icon="money"
      label={
        <>
          {SEARCH_INTERNSHIP_REFINEMENT_LABELS.payment}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="payment"
        initialValue={selectedFacetValues}
        options={Object.entries(PAYMENT_LEVELS).map(([name, label]) => ({
          name,
          label,
        }))}
      />
    </FacetVariant>
  );
}
